import React from 'react'
import {
  ArrowDiv,
  ArrowDivBG,
  SwiperScrollNext,
  SwiperScrollPrev,
} from '../MainRailPage/MainRailPage.style'

interface PrevButtonProps {
  prevButton: boolean
  toggleNextButton: (nextButton: boolean) => void
}
interface NextButtonProps {
  nextButton: boolean
  togglePrevButton: (nextButton: boolean) => void
}

const PrevButton: React.FC<PrevButtonProps> = ({
  prevButton,
  toggleNextButton,
}) => {
  return (
    <SwiperScrollPrev
      className='swiper-button-prev-custom'
      disabled={prevButton}
      onClick={() => prevButton && toggleNextButton(true)}
    >
      <ArrowDivBG type={'prev'} />
      <ArrowDiv className={'ArrowDiv'} type={'prev'} />
    </SwiperScrollPrev>
  )
}

const NextButton: React.FC<NextButtonProps> = ({
  nextButton,
  togglePrevButton,
}) => {
  return (
    <SwiperScrollNext
      className='swiper-button-next-custom'
      disabled={nextButton}
      onClick={() => nextButton && togglePrevButton(true)}
    >
      <ArrowDivBG type={'next'} />
      <ArrowDiv className={'ArrowDiv'} type={'next'} />
    </SwiperScrollNext>
  )
}

export { PrevButton, NextButton }
